import { getDocumentOptions, getDocumentQueryKey } from '@helios/frontend-api-v2-client';
import { useQuery } from '@tanstack/react-query';

import { getFriendlyError } from '../../utils/error';

import { CustomerTerms } from './customerTerms';

export const QUERY_KEY_CUSTOMER_TERMS = getDocumentQueryKey;

export interface UseCustomerTerms {
  data?: CustomerTerms;
  isFetched: boolean;
  isLoading: boolean;
  error?: string;
}

export const useCustomerTerms = (termName: string): UseCustomerTerms => {
  const query = useQuery({
    ...getDocumentOptions({ path: { termName } }),
    enabled: Boolean(termName),
  });

  return {
    data: query.data,
    isFetched: query.isFetched,
    isLoading: query.isPending,
    error: getFriendlyError(query.error, 'customer terms'),
  };
};

export default useCustomerTerms;
